export default __webpack_public_path__ + "static/media/SetupLab_FR.2b5cc96c.pdf";